/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
(function( $ ) {
    "use strict";

    // home intro video, close popup @end
    document.addEventListener( "ended", function( e ){
	$( e.target ).closest( ".elementor-popup-modal" ).find( ".dialog-close-button" ).click();
    }, true);
    // close @scroll
    $( window ).bind( "mousewheel DOMMouseScroll", function( e ){
	//console.log("mouse wheel", e);
	var $modal = $( e.target ).closest( "#elementor-popup-modal-733" );
	if ( $modal.length ) {
	    $modal.find( ".dialog-close-button" ).click();
	}
    });
    // close @touch
    $( document ).on( "touchstart", "#elementor-popup-modal-733", function( e ) {
	$( e.currentTarget ).find( ".dialog-close-button" ).click();
    });
    
    // download files for specs
    $( document ).on( "click", ".elementor-widget-form.infos button[type=submit]", function() {
	var target = $( this.form ).find( '[name="form_fields[millesime]"]' ).val();
	if ( target ) {
	    window.location.href = target;
	    return false;
	}
    });
}( jQuery ) );
